<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="login-card md-layout-item md-size-33">
      <login-form />
    </div>
  </div>
</template>

<script>
import LoginForm from '~lib/common/components/LoginForm';

export default {
  components: {
    LoginForm
  },
};
</script>

<style>
.login-card {
  min-width: 400px !important;
}

.md-layout {
  height: 100%
}
</style>
